import { type ReactNode } from 'react';
import { BASE_PATH } from '../lib/basePath';

/**
 * Wordmark Varga Car Service (`brand/`, teste D1 — provisório). Texto já
 * vetorizado. Versão reverse no tema escuro via `<picture>` + `prefers-color-scheme`
 * (o portal não tem toggle de tema, então o media query basta). `largura` em px:
 * 108 discreto na Home, 140 na landing, 180 nas telas de auth (DESIGN-FOUNDATION
 * §6.7 / §6.8).
 */
export function Wordmark({ largura = 108 }: { largura?: number }): ReactNode {
  return (
    <picture>
      <source
        srcSet={`${BASE_PATH}/brand/wordmark-reverse.svg`}
        media="(prefers-color-scheme: dark)"
      />
      <img
        src={`${BASE_PATH}/brand/wordmark.svg`}
        alt="Varga Car Service"
        width={largura}
        height={Math.round((largura * 189.6) / 597.6)}
        style={{ width: largura, height: 'auto' }}
      />
    </picture>
  );
}
